namespace GeniuzPOS.AdvPromo {
    export class PsPromoTypeColumns {
        static columnsKey = 'AdvPromo.PsPromoType';
    }
}
